import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from 'react-query'
import { 
  Plus, 
  FileText, 
  Users, 
  Package, 
  Banknote, 
  Calendar,
  MessageSquare,
  Settings,
  User,
  Clock,
  BarChart3,
  Shield
} from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { dashboardService } from '@/services/dashboardService'
import AuditTrailModal from './AuditTrailModal'

const QuickActions = () => {
  const { hasPermission } = useAuth()
  const [showAuditTrail, setShowAuditTrail] = useState(false)
  
  const { data: quickActionsData, isLoading } = useQuery(
    'dashboard-quick-actions',
    dashboardService.getQuickActions,
    {
      select: (response) => response.data,
      refetchInterval: 10 * 60 * 1000, // Refetch every 10 minutes
    }
  )

  const getIcon = (iconName) => {
    const icons = {
      'user': User,
      'calendar': Calendar,
      'clock': Clock,
      'folder': Plus,
      'user-plus': Users,
      'settings': Settings,
      'bar-chart': BarChart3,
      'file-text': FileText,
      'package': Package,
      'dollar-sign': Banknote,
      'message-square': MessageSquare
    }
    return icons[iconName] || Plus
  }

  const actions = quickActionsData?.quickActions || []
  
  if (isLoading) {
    return (
      <div className="bg-white rounded-2xl" style={{ border: '0.5px solid #e5e7eb' }}>
        <div className="p-6">
          <div className="animate-pulse">
            <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
            <div className="grid grid-cols-2 gap-3">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="h-12 bg-gray-300 rounded-xl"></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-white rounded-2xl" style={{ border: '0.5px solid #e5e7eb' }}>
      <div className="p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Quick Actions</h3>
        
        <div className="grid grid-cols-2 gap-3">
          {/* Audit Trail Button */}
          <button
            onClick={() => setShowAuditTrail(true)}
            className="flex items-center justify-center p-3 rounded-xl text-white bg-purple-600 hover:bg-purple-700 transition-all hover:shadow-lg"
          >
            <Shield className="h-4 w-4 mr-2" strokeWidth={1.5} />
            <span className="text-sm font-medium">Audit Trail</span>
          </button>
          
          {actions.slice(0, 5).map((action) => {
            const IconComponent = getIcon(action.icon)
            const colorClass = action.color || 'bg-blue-600 hover:bg-blue-700'
            
            return (
              <Link
                key={action.id}
                to={action.url}
                className={`flex items-center justify-center p-3 rounded-xl text-white transition-all hover:shadow-lg ${colorClass}`}
              >
                <IconComponent className="h-4 w-4 mr-2" strokeWidth={1.5} />
                <span className="text-sm font-medium">{action.title}</span>
              </Link>
            )
          })}
        </div>
        
        {actions.length > 5 && (
          <div className="mt-4 pt-4 border-t" style={{ borderColor: '#e5e7eb' }}>
            <button className="w-full text-center text-sm text-[#DF6B38] hover:text-[#c85f30] font-medium">
              View more actions →
            </button>
          </div>
        )}
      </div>
      
      {/* Audit Trail Modal */}
      <AuditTrailModal 
        isOpen={showAuditTrail} 
        onClose={() => setShowAuditTrail(false)} 
      />
    </div>
  )
}

export default QuickActions